<!--
 * @Author: chenxing
 * @Date: 2021-04-07 20:00:21
 * @LastEditors: chenxing
 * @LastEditTime: 2021-05-27 16:27:58
-->
<template>
  <a-result status="500" title="500" sub-title="抱歉，服务器好像出了一点问题">
    <template #extra>
      <a-button type="primary" @click="toHome">
        回到首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
  export default {
    name: 'Exception500',
    methods: {
      toHome () {
        this.$router.push({ path: '/' });
      }
    }
  };
</script>
